<footer class="footer">
  Copyright &copy; 2023-{{ this.currentYear }} by
  <a target="_blank" href="https://code-mint.com/" class="link">CodeMint</a>
</footer>
